const authentication = require('../../../react-azure-adb2c2').default;





export const list = (values: any) => {


    const url = process.env.REACT_APP_API_BASE_URL + `/api/AutoSendsTemplates/`;



    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(search),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const details = (value: any) => {


    // const url = `http://localhost:5000/api/v1/mail/templates/details/`+value
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/api/v1/mail/templates/details/`+value



    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(search),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};